import { AvailableLanguages } from '@repo/toolkit/language-types'
import Typography, { TypographyProps } from '@repo/ui/typography'

import useTranslate from '../../lib/hooks/use-translate'

type TranslatedTypography = Record<AvailableLanguages, string>

type TranslatedTypographyProps = TypographyProps & {
  keys: TranslatedTypography
}

// Function to get the translated typography based on the language
export const getTranslatedTypography = (
  keys: TranslatedTypography,
  currentLanguage: AvailableLanguages
) => {
  const title = keys[currentLanguage] // Get the translated string based on current language
  return title || keys.fr // Fallback to English if translation not found
}

// Component to render the translated typography based on current language
const TranslatedTypography = ({ keys, ...props }: TranslatedTypographyProps) => {
  const { currentLanguage } = useTranslate() // Get current language
  const title = getTranslatedTypography(keys, currentLanguage) // Get the translated title

  return <Typography {...props}>{String(title)}</Typography> // Render Typography with translated title
}

export default TranslatedTypography
